
<template>
  <div class="musicmor">
    <Headers></Headers>
    <div class="musicmor-center">
      <img
        src="https://aliyunosszs.musicwow.com/APPimg/product/product(5).png"
      />
      <div class="center-body">
        <ul class="musicList">
          <li v-for="(item, idx) in listData" :key="idx">
            <div class="musicList-left">
              <img :src="item.cover" />
            </div>
            <div class="musicList-items">
              <p class="items-title">{{ item.title }}</p>
              <p class="items-show">产品描述：</p>
              <div class="items-text">
                {{ item.describe }}
              </div>
              <div class="items-mor" @click="onMusicData(item.id)">
                了解详情 >
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "musicmor",
  data() {
    return {
      navData: [
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/product/product(8).png",
          title: "TOMMY CHAN《全能职业吉他手》",
          text: "一句话描述一句话描述一句话描述",
          mon: "490",
        },
        {
          imgUrl:
            "https://aliyunosszs.musicwow.com/APPimg/product/product(9).png",
          title: "江建民《天才吉他手II》",
          text: "一句话描述一句话描述一句话描述",
          mon: "490",
        },
      ],
      listData: [],
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {
    onMusicData(id) {
      localStorage.detailsId = id || localStorage.detailsId;
      this.$router.push({ name: "MusicwowDetails", params: { id: id } });
    },
  },
  mounted() {},
  async created() {
    let productData = await this.$API.getProductData({});
    this.listData = productData.data;
    // console.log(this.listData)
  },
};
</script>
<style lang="sass" scoped>
.musicmor
  .musicmor-center
    padding-top: 60px
    img
      width: 100%
    .center-body
      margin: 20px 0
      .musicList
        margin: 0 35px
        li
          display: flex
          margin: 30px 0
          align-items: center
          .musicList-left
            flex: 6
            text-align: left
            img
              width: 115px !important
          .musicList-items
            flex: 6
            text-align: left
            margin-left: auto
            .items-title
              font-size: 20px
            .items-show
              font-size: 12px
              color: #000000
              margin-top: 10px
              line-height: 20px
            .items-text
              color: #9E9E9E
              max-width: 90px
              line-height: 20px
            .items-mor
              border-radius: 18px
              border: 1px solid #979797
              width: 69px
              padding: 5px 0
              text-align: center
              font-size: 10px
              color: #5C5C5C
              margin-top: 35px
</style>

